module.exports = __webpack_public_path__ + "static/media/ex5.4ba37a98.jpg";